import React from 'react'

const GalleryImageCard = ({ imageUrl }) => {
  return (
    <div className="w-[400px] h-[400px] max-md:w-[300px] max-md:h-[300px] max-sm:w-[250px] max-sm:h-[250px] mx-2 inline-block">
      <img className="w-full h-full object-cover" src={imageUrl} alt="Truekeepers" />
    </div>
  )
}

export default GalleryImageCard